<div class="action-cards">
  <div class="card" *ngIf="!customerInfo?.email">
    <img src="./images/customer-profile/mail.png" alt="" loading="lazy">
    <h4 i18n="@@profile.action_cards.add_your_email">Add your email</h4>
    <p i18n="@@profile.action_cards.easily_recover_your_account">Easily recover your account and stay in the loop with the latest news.</p>
    <button i18n="@@profile.action_cards.add_email" (click)="openAccountSettingsModal('general')">Add email</button>
  </div>
  <div class="card" *ngIf="!customerInfo.addresses || customerInfo.addresses.length === 0">
    <img src="./images/customer-profile/location.png" alt="" loading="lazy">
    <h4 i18n="@@profile.action_cards.add_your_address">Add your address</h4>
    <p i18n="@@profile.action_cards.simplify_orders_get_faster_service">Simplify orders, get faster service, and see options that work best for your location.</p>
    <button i18n="@@profile.action_cards.add_address" (click)="openAddressModal()">Add address</button>
  </div>
  <div class="card" *ngIf="!customerInfo?.dob">
    <img src="./images/customer-profile/birthday.png" alt="" loading="lazy">
    <h4 i18n="@@profile.action_cards.add_your_birth_date">Add your birth date</h4>
    <p>Celebrate your milestones with exclusive rewards and gifts.</p>
    <button (click)="openAccountSettingsModal('general')">Add birth date</button>
  </div>
  <!-- <div class="card">
    <img src="./images/customer-profile/payment.png" alt="">
    <h4>Add payment info</h4>
    <p>Streamline checkouts and manage your payments with ease.</p>
    <button (click)="openAccountSettingsModal('payment')">Add payment methods</button>
  </div> -->
</div>
<app-account-settings-modal 
  [isOpen]="isAccountSettingsModalOpen" 
  [activeTab]="activeAccountSettingsTab"
  (close)="closeAccountSettingsModal()">
</app-account-settings-modal>